// extracted by mini-css-extract-plugin
export var dealRoom = "styles-module--dealRoom--dfgK7";
export var fancyOl = "styles-module--fancy-ol--c0Iz3";
export var primary = "#06004d";
export var secondary = "#4dafd7";
export var visible = "styles-module--visible--wMbej";